export const IconCashierFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M21.75 3c0-.464-.184-.909-.513-1.237A1.75 1.75 0 0 0 20 1.25h-7c-.464 0-.909.184-1.237.513A1.75 1.75 0 0 0 11.25 3v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h7c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zM22.75 17a.75.75 0 0 0-.75-.75H2a.75.75 0 0 0-.75.75v4c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zM10 20.25h4a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M17.25 9.5V7a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M1.466 15.333q.253-.082.534-.083h20q.28.001.534.083l-.675-5.064a1.75 1.75 0 0 0-1.735-1.519H3.876a1.75 1.75 0 0 0-1.735 1.519zM17 14.25h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5m-3.5 0h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5m-8-1.5h4a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5m11.5-1h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5m-3.5 0h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5"
        clipRule="evenodd"
      />
    </svg>
  );
};
